if (!customElements.get('dropdown-link')) {
  class DropdownLink extends HTMLElement {
    static selectors = {
      head: '[js-dropdown-link-head]',
      body: '[js-dropdown-link-body]',
    };

    static ACTIVE_CLASS = 'is-active';

    constructor() {
      super();

      this.handleCloseRef = this.handleClose.bind(this);
      this.handleKeydownRef = this.handleKeydown.bind(this);
    }

    setExpanded(expanded) {
      this.classList.toggle(DropdownLink.ACTIVE_CLASS, expanded);
      this.head.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    handleToggle(event) {
      event.preventDefault();
      event.stopPropagation();

      this.setExpanded(!this.classList.contains(DropdownLink.ACTIVE_CLASS));
    }

    handleClose() {
      this.setExpanded(false);
    }

    handleKeydown(event) {
      if (event.code?.toUpperCase() === 'ESCAPE') {
        this.setExpanded(false);
        this.head.focus();
        return;
      }

      if (
        event.code?.toUpperCase() === 'SPACE' &&
        event.target === this.head
      ) {
        event.preventDefault();
        this.handleToggle(event);
      }
    }

    connectedCallback() {
      this.head = this.querySelector(DropdownLink.selectors.head);
      this.body = this.querySelector(DropdownLink.selectors.body);

      if (!this.head || !this.body) return;

      this.head.addEventListener('click', this.handleToggle.bind(this));
      this.addEventListener('keydown', this.handleKeydownRef);

      document.body.addEventListener('click', this.handleCloseRef);
    }
  }

  customElements.define('dropdown-link', DropdownLink);
}
